export enum PopoverAnchor {
    TopRight = "TopRight",
    TopLeft = "TopLeft",
    BottomRight = "BottomRight",
    BottomLeft = "BottomLeft",
}
